let axios = null
let publicAxios = null

const toBaseURL = (instance) => (instance.defaults.baseURL + "").replace(/\/api[\/]*$/, '')

export const getApi = () => {
    return { api: axios, baseURL: toBaseURL(axios) };
}
export const setApi = api => axios = api;

/**
 * Instance for unauthenticated endpoints. Falls back to the authenticated one,
 * whose interceptors redirect on 401/403/404 — a public page has to render its
 * own unavailable state instead, so pass a credential-free instance via
 * `initializeQueries(app, api, publicApi)`.
 */
export const getPublicApi = () => {
    const api = publicAxios ?? axios;
    return { api, baseURL: toBaseURL(api) };
}
export const setPublicApi = api => publicAxios = api;
